import type { Pool } from 'templates/pool/types';

type PoolWithOwnerFields = Pool & { managerId?: string; userId?: string; ownerId?: string };

export function isPoolManagerUser(pool: Pool, userId: string | undefined | null): boolean {
  if (userId == null) return false;
  const uid = String(userId).trim();
  if (!uid) return false;

  if (pool.manager?.id != null && String(pool.manager.id).trim() === uid) return true;

  const p = pool as PoolWithOwnerFields;
  if (p.managerId != null && String(p.managerId).trim() === uid) return true;
  if (p.userId != null && String(p.userId).trim() === uid) return true;
  if (p.ownerId != null && String(p.ownerId).trim() === uid) return true;

  return false;
}
